import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { WasteTabs } from '@components/tables/WasteTableTabs'

interface WasteState {
  activeTab: WasteTabs
}

const initialState: WasteState = {
  activeTab: WasteTabs.Entries,
}

const wasteSlice = createSlice({
  name: 'waste',
  initialState,
  reducers: {
    setActiveTab(state, action: PayloadAction<WasteTabs>) {
      state.activeTab = action.payload
    },
    resetActiveTab: (state) => {
      state.activeTab = WasteTabs.Entries
    },
  },
})

export default wasteSlice.reducer
export const { setActiveTab, resetActiveTab } = wasteSlice.actions
